import * as React from "react";
import { withStyles } from "src/decorators";
import styled, { css, CSSProperties, DefaultTheme } from "styled-components";

type ITextProps = React.HTMLProps<HTMLParagraphElement & HTMLHeadingElement> & {
  as?: string;
  fontWeight?: keyof DefaultTheme["text"]["fontFamily"];
  fontSize?: keyof DefaultTheme["text"]["size"];
  color?: keyof DefaultTheme["colors"]["text"];
  uppercase?: boolean;
  capitalize?: boolean;
  align?: "left" | "center" | "right";
  underline?: boolean;
  truncate?: boolean;
  whiteSpace?: CSSProperties["whiteSpace"];
  wordBreak?: CSSProperties["wordBreak"];
  italic?: boolean;
  lineHeight?: keyof DefaultTheme["text"]["lineHeight"];
};

const TextEl = styled.div<Required<ITextProps>>`
  line-height: 1.33;

  ${(p) => css`
    color: ${p.theme.colors.text[p.color]};
    font-family: ${p.theme.text.fontFamily[p.fontWeight]};
    font-size: ${p.theme.text.size[p.fontSize]};
    line-height: ${p.theme.text.lineHeight[p.lineHeight]};
  `}

  ${(p) =>
    p.uppercase &&
    css`
      text-transform: uppercase;
    `}

  ${(p) =>
    p.capitalize &&
    css`
      text-transform: capitalize;
    `}

${(p) =>
    p.underline &&
    css`
      text-decoration: underline;
    `}

${(p) =>
    p.truncate &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

${(p) =>
    p.whiteSpace &&
    css`
      white-space: ${p.whiteSpace};
    `}

  ${(p) =>
    p.wordBreak &&
    css`
      word-break: ${p.wordBreak};
    `}

${(p) =>
    p.align &&
    css`
      text-align: ${p.align};
    `}
  
${(p) =>
    p.italic &&
    css`
      font-style: italic;
    `}
`;

TextEl.displayName = "Text";

export const Text = withStyles(({ children, ...other }: ITextProps) => {
  const _propsWithDefaultValues = {
    as: "p",
    fontWeight: "normal",
    fontSize: "normal",
    color: "readable",
    ...other,
  };

  return <TextEl {...(_propsWithDefaultValues as any)}>{children}</TextEl>;
});
